import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import {
  Row,
  Col,
  Table,
  Button,
} from 'reactstrap';
import { fetchContextsInitAction } from '../../../../../actions/instances/context';
import Icon from '../../../../atoms/Icon/Icon';
import './SelectContextModal.scss';

const SelectContextModal = ({
  onItemSelected,
}) => {
  const {
    contexts,
    didLoadContexts,
    isLoadingContexts,
  } = useSelector(state => state.contexts);
  const dispatch = useDispatch();
  useEffect(() => {
    if (!didLoadContexts && !isLoadingContexts) {
      dispatch(fetchContextsInitAction());
    }
  }, []);
  return (
    <div>
      <Row>
        <Col md={12}>
          <Table responsive striped bordered>
            <colgroup>
              <col width="10%" />
              <col width="60%" />
              <col width="20%" />
              <col width="10%" />
            </colgroup>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Dynasty</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {contexts.map(con => (
                <tr>
                  <td>{con.code}</td>
                  <td>{`${con.name} [${con.code}]`}</td>
                  <td>{`${con.dynasty.name} [${con.dynasty.code}]`}</td>
                  <td className="text-center">
                    <Button size="sm" color="light" onClick={() => onItemSelected(con)}>
                      <Icon icon="check" color="#000" />
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </div>
  );
};

SelectContextModal.propTypes = {
  onItemSelected: PropTypes.func.isRequired,
};

SelectContextModal.defaultProps = {

};

export default SelectContextModal;
